/**
 * Jumbotron
 */

// Module dependencies
import 'protons';
import 'atoms/image';
import 'atoms/button';

// Module template
import './_jumbotron.twig';

// Module styles
import './_jumbotron.scss';

export const name = 'jumbotron';

export function disable() {}

export function enable() {}

export default enable;
